import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { values } from '@mews/fp';
import { TabItemValue } from './enums';

export const isTabItemValue = (value: string): value is TabItemValue =>
    pipe(
        TabItemValue,
        values,
        array.findFirst((enumValue) => enumValue === value),
        option.isSome
    );
